export default __webpack_public_path__ + "images/1fd717b022ed260a3c8b5b5abce597b9-seasonal_module_spd_bar_crawls_desktop.webp";